import {
  CCol,
  CForm,
  CFormFeedback,
  CFormLabel,
  CLoadingButton,
  CMultiSelect,
} from '@coreui/react-pro'
import React, { useCallback, useEffect, useState } from 'react'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import ToastComponent from 'src/components/common/TaostComponent'
import EmailQuotaService from 'src/service/EmailQuotaService'
import EmailMemberListing from './EmailMemberListing'
import './GameNotification.css'
const CreatEmailMember = (props) => {
  const [memberList, setMemberList] = useState([])
  const [saving, setSaving] = useState(false)
  useEffect(() => {
    EmailQuotaService.getMemberList().then((res) => {
      if (res.status === 200) {
        setMemberList(res.data)
      }
    })
  }, [])

  const validationSchema = Yup.object().shape({
    members: Yup.array().min(1, 'At least one member is required').required('Members are required'), // Optional, as min(1) covers it
    message: Yup.string().required('Message is required'),
  })
  const formik = useFormik({
    initialValues: {
      members: [],
      message: '',
    },
    enableReinitialize: true,
    validationSchema,
    onSubmit: (data) => {
      // data.members = selectedValue
      setSaving(true)
      EmailQuotaService.saveEmailMembers(data)
        .then((res) => {
          if (res.status === 200) {
            fetchUsers()
            ToastComponent(res.message, res.duplicate_members?.length ? 'warning' : 'success')
          } else {
            ToastComponent(res.message, 'error')
          }
        })
        .catch((e) => {
          ToastComponent('Something Went wront. Please try again.', 'error')
        })
        .finally(() => setSaving(false))
    },
  })

  const [activePage, setActivePage] = useState(1)
  const [columnFilter, setColumnFilter] = useState({})
  const [columnSorter, setColumnSorter] = useState(null)
  const [itemsPerPage, setItemsPerPage] = useState(10)
  const [users, setUsers] = useState(props.users)
  const [details, setDetails] = useState([])
  const [selectedCheckboxes, setSelectedCheckboxes] = useState([])
  const [sentEmailIds, setSentEmailIds] = useState([])
  const fetchUsers = useCallback(async () => {
    const offset = itemsPerPage * activePage - itemsPerPage
    let params = new URLSearchParams()
    Object.keys(columnFilter).forEach((key) => {
      params.append(key, columnFilter[key])
    })
    columnSorter &&
      columnSorter.column !== undefined &&
      params.append('sort', `${columnSorter.column}%${columnSorter.state}`)

    try {
      const result = await EmailQuotaService.getEmailMember(
        offset,
        itemsPerPage,
        activePage,
        params,
      )
      setUsers(result.data)
      setSentEmailIds(result.sent_email_ids)
    } catch (error) {
      console.error('Error fetching users:', error)
    } finally {
    }
  }, [activePage, itemsPerPage, columnFilter, columnSorter])

  useEffect(() => {
    fetchUsers()
  }, [fetchUsers])

  return (
    <div className="gn-members-grid">
      <div className="gn-compose">
        <h3 className="gn-compose-title">New message</h3>
        <CForm className="row g-3" onSubmit={formik.handleSubmit}>
          <CCol xs={12}>
            <CFormLabel htmlFor="members">Members *</CFormLabel>
            <CMultiSelect
              id="members"
              options={memberList}
              selectionType="tags"
              name="members"
              onChange={(selected) => {
                // Mark touched first without validating (shouldValidate=false): Formik's
                // setFieldTouched validates against the pre-update `values`, so if it ran
                // after setFieldValue it would race and reinstate a stale "required" error
                // even though a member was just selected.
                formik.setFieldTouched('members', true, false)
                formik.setFieldValue('members', selected)
              }}
              value={formik.values.members}
              invalid={formik.touched.members && !!formik.errors.members}
            />
            <CFormFeedback invalid>{formik.touched.members && formik.errors.members}</CFormFeedback>
          </CCol>
          <CCol xs={12}>
            <CFormLabel htmlFor="message">Message *</CFormLabel>
            <textarea
              name="message"
              id="message"
              rows={5}
              className={
                'form-control' +
                (formik.errors.message && formik.touched.message ? ' is-invalid' : '')
              }
              placeholder="Write the message members will receive..."
              defaultValue={formik.values.message}
              onChange={formik.handleChange}
            />
            {formik.errors.message && formik.touched.message && (
              <CFormFeedback invalid>{formik.errors.message}</CFormFeedback>
            )}
            <p className="gn-helper">
              Adds one queued email per member. Nothing sends until you send it from the queue.
            </p>
          </CCol>
          <CCol xs={12}>
            <CLoadingButton
              type="submit"
              color="primary"
              id="submit"
              loading={saving}
              disabled={saving}
            >
              Add to queue
            </CLoadingButton>
          </CCol>
        </CForm>
      </div>

      <div>
        <EmailMemberListing
          details={details}
          setUsers={setUsers}
          setDetails={setDetails}
          selectedCheckboxes={selectedCheckboxes}
          setSelectedCheckboxes={setSelectedCheckboxes}
          users={users}
          fetchUsers={fetchUsers}
          setActivePage={setActivePage}
          setItemsPerPage={setItemsPerPage}
          setColumnFilter={setColumnFilter}
          setColumnSorter={setColumnSorter}
          itemsPerPage={itemsPerPage}
          activePage={activePage}
          columnFilter={columnFilter}
          columnSorter={columnSorter}
          sentEmailIds={sentEmailIds}
        />
      </div>
    </div>
  )
}

export default CreatEmailMember
